import React, { ReactNode } from "react"

import { IconButtonProps } from "@mui/material/IconButton/IconButton"

import { StyledIconButton } from "./styled"

interface IProps extends IconButtonProps {
  muiIcon?: ReactNode,
  customContent?: string,
  shade?: "dark" | "light",
  pending?: boolean
}

export const IconButton = ({
                             children,
                             muiIcon,
                             customContent,
                             ...props }: IProps) => {

  return <StyledIconButton size="medium"
                           color="default"
                           {...props}>
    {customContent || muiIcon || children}
  </StyledIconButton>
}
